import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonSurveyList } from "./Common/CommonSurveyList";

const SurveyPage = () => {
    return (
        <PageWrapper title='Questionários'>
            <Page container='fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <CommonSurveyList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default SurveyPage;